// import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
// import { environment } from './environments/environment';

// Sentry.init({
//   environment: environment.environment,
//   dsn: environment.sentryDsn,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     // Sentry.replayIntegration(),
//     Sentry.consoleLoggingIntegration({ levels: ['error'] }),
//   ],
//   tracesSampleRate: 1,
//   // replaysSessionSampleRate: 0.1,
//   // replaysOnErrorSampleRate: 1,
// });

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
